import { TransferRequestType, TransferRequestItemType } from 'models/transfer-request.model';
import { BatchType } from 'models/item-request.model';
import { Dispatch, SetStateAction } from 'react';

const getTotalQuantitySent = (batches: BatchType[]) => {
  return batches.reduce((quantity, batch) => quantity + Number(batch.quantity), 0);
};

const isSameBatch = (left: BatchType, right: BatchType) => {
  if (left.batch_id && right.batch_id) {
    return left.batch_id === right.batch_id;
  }
  return left.batch_no === right.batch_no;
};

export const updateBatchQuantity = (
  active: BatchType,
  e: any,
  setItemToUpdate: Dispatch<SetStateAction<TransferRequestType>>,
  item: TransferRequestItemType
) => {
  const newValue = e.target.value;
  if (newValue === '' || Number(newValue) <= Number(item.quantity))
    setItemToUpdate((prev) => ({
      ...prev,
      items: prev.items.map((itemToUpdate) =>
        itemToUpdate.id === item.id
          ? {
              ...itemToUpdate,
              batches: itemToUpdate.batches.map((batch) =>
                isSameBatch(batch, active) ? { ...batch, quantity: newValue } : batch
              ),
              new_quantity_sent: getTotalQuantitySent(
                itemToUpdate.batches.map((batch) =>
                  isSameBatch(batch, active) ? { ...batch, quantity: newValue } : batch
                )
              )
            }
          : itemToUpdate
      )
    }));
};

export const removeBatch = (
  b: BatchType,
  setItemToUpdate: Dispatch<SetStateAction<TransferRequestType>>,
  item: TransferRequestItemType
) => {
  setItemToUpdate((prev) => ({
    ...prev,
    items: prev.items.map((itemToUpdate) =>
      itemToUpdate.id === item.id
        ? {
            ...itemToUpdate,
            batches: itemToUpdate.batches.filter((batch) => !isSameBatch(batch, b))
          }
        : itemToUpdate
    )
  }));
};

export const updateBatchNo = (
  val: { name: string; id: string; batchNo?: number },
  b: BatchType,
  setItemToUpdate: Dispatch<SetStateAction<TransferRequestType>>,
  item: TransferRequestItemType
) => {
  const parsedBatchNo =
    val.batchNo ?? Number(String(val.name).replace(/[^0-9]/g, '')) ?? Number(b.batch_no) ?? 0;

  setItemToUpdate((prev) => ({
    ...prev,
    items: prev.items.map((itemToUpdate) =>
      itemToUpdate.id === item.id
        ? {
            ...itemToUpdate,
            batches: itemToUpdate.batches.map((batch) =>
              isSameBatch(batch, b)
                ? { ...batch, batch_no: parsedBatchNo, batch_id: val.id }
                : batch
            )
          }
        : itemToUpdate
    )
  }));
};
